module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-67f98f98.png";